module.exports = __webpack_public_path__ + "img/resolute1.4fe44b6f.webp";